<template>
    <div class="faqs" :class="{'grey' : isAuEm}" id="faqs">
        <div class="container">
          <h2 data-aos="zoom-in" data-aos-offset="200">{{ data.title }}</h2>
          <div class="faqs__list">
            <div class="faqs__column faqs__column--left">
              <div v-for="(item, i) in data.questionsLeft" data-aos="fade-up" data-aos-offset="300">
                <h3 class="question questionLeft"  @click="answerQuestion(i, 'Left')">{{ item.question }}</h3>
                <div class="chapter chapterLeft" v-html="item.answer">
                </div>
              </div>
            </div>

            <div class="faqs__column faqs__column--right">
              <div v-for="(item, ii) in data.questionsRight" data-aos="fade-up" data-aos-offset="300">
                <h3 class="question questionRight"  @click="answerQuestion(ii, 'Right')">{{ item.question }}</h3>
                <div class="chapter chapterRight" v-html="item.answer">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
</template>

<script>
import Content from "../data/content";
let lang = process.env.VUE_APP_LOCALITY;

  export default {
    methods: {
      async answerQuestion(number, side) {
        let question = document.getElementsByClassName('question' + side);
        let answer = document.getElementsByClassName('chapter' + side);

        question[number].classList.toggle('active');
        answer[number].classList.toggle('active-div');

        if (answer[number].classList.contains('active-div')) {
          window.dataLayer = window.dataLayer || [];
          dataLayer.push({
            "event": "faq_view",
            "component_type": "faq",
            "component_name": question[number].textContent,
          });
        }
      }
    },
    data: function() {
      return {
        data: Content[lang].faqs,
        isAuEm: lang == 'pl_en' ? true : false,
      }
  },
  };
  </script>

<style>
/* FAQs */

.footer-image {
  background: #FAFAFA;
}

.faqs {
  background: #FAFAFA;
}

.faqs .container {
  max-width: 821px;
  margin: 0 auto;
  padding: 76px 0 50px;
}

.faqs h2 {
  text-align: center;
  font-size: 34px;
  line-height: 120%;
  font-family: 'jet-extrabold';
}

.faqs__list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.faqs__column {
  width: calc(50% - 25px);
  max-widtH: 354px;
}

.faqs__column h3::after {
  left: -31px;
  transform: rotate(45deg);
}

.faqs__column h3 {
  margin-left: 20px;
  border-top: none;
}

.faqs .question {
  border-bottom: none;
}

.faqs .question.active::after {
  transform: rotate(135deg);
  border-top: 2px solid #ff8000;
  border-right: 2px solid #ff8000;
}

.faqs .question.active {
  color: #ff8000;
}

.faqs .chapter {
  margin-left: 20px;
  overflow: hidden;
}

.faqs ul {
  list-style-type: disc;
  margin: 0 auto 0 20px;
}

.faqs li {
  font-size: 16px !important;
  color: #242E30 !important;
  display: list-item !important;
  padding-left: 0 !important;
}

.faqs .chapter.active-div {
  height: auto;
}

.faqs h3:hover {
  color: #ff8000;
}

.faqs h3:hover::after {
  border-top: 2px solid #ff8000;
  border-right: 2px solid #ff8000;
}


@media only screen and (max-width: 768px) {
  .faqs h2 {
    font-size: 26px;
    margin-bottom: 20px;
  }
  .faqs__column {
    width: 100%;
    max-width: none;
  }
  .faqs__column h3 {
    margin-left: 18px;
    border-top: none;
    padding-right: 0;
    margin-left: 50px;
    margin-right: 50px;
    width: calc(100% - 100px);
    padding-top: 0;
  }
  .faqs h3:hover {
    padding: 0 0 14px 0;
  }
  .faqs h3:after {
    top: 7px !important;
  }
  .faqs .chapter {
    margin-left: 50px;
    margin-right: 50px;
  }
  .faqs .chapter li {
    font-size: 14px !important;
  }
  .faqs .chapter.active-div, .faqs .chapter p {
    padding-right: 0;
  }
}
</style>